import * as React from 'react';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import styled from 'styled-components';
import ReactTable, { Column, RowRenderProps } from 'react-table';
import 'src/ReactTableStyles.css';
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Solution } from 'src/models/Solution';
import { ErrorMessages } from '../Globals/Globals';

const RelatedSolutionsWrapper = styled(Flex)`
  width: 100%;
`;

const StyledReactTable = styled(ReactTable)`
  width: 100%;
`;

interface IRelatedSolutionsProps {
  relatedSolutions?: Solution[];
}

const TableColumn = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
`;

export class RelatedSolutionsTable extends React.Component<IRelatedSolutionsProps> {
  constructor(props: IRelatedSolutionsProps) {
    super(props);
  }

  public renderColumnWithLink(data: RowRenderProps) {
    return <Link to={`/offering/${data.original.id}`}>{data.value}</Link>;
  }

  public renderTableHeader(text: string) {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {text}
        <FontAwesomeIcon icon="sort" />
      </div>
    );
  }

  public render() {
    const columns: Column[] = [
      {
        Header: (data, column) => this.renderTableHeader('Solution name'),
        accessor: 'solutionName',
        Cell: row => this.renderColumnWithLink(row),
        minWidth: 100
      },
      {
        Header: (data, column) => this.renderTableHeader('Offering type'),
        accessor: 'offeringType',
        Cell: row => {
          return <TableColumn title={row && row.value}>{row && row.value}</TableColumn>;
        }
      },
      {
        Header: (data, column) => this.renderTableHeader('Product manager'),
        accessor: 'productManager',
        Cell: row => {
          return <TableColumn title={row && row.value}>{row && row.value}</TableColumn>;
        }
      },
      {
        Header: (data, column) => this.renderTableHeader('Business line'),
        accessor: 'businessLine',
        Cell: row => {
          return (
            <TableColumn title={row && row.value.join(', ')}>
              {row && row.value.join(', ')}
            </TableColumn>
          );
        }
      }
    ];

    return (
      <RelatedSolutionsWrapper direction={FlexDirection.column}>
        <StyledReactTable
          data={this.props.relatedSolutions}
          columns={columns}
          minRows={4}
          pageSize={this.props.relatedSolutions && this.props.relatedSolutions.length}
          className="-striped -highlight"
          noDataText={ErrorMessages.noRelatedSolutions}
          showPageSizeOptions={false}
          showPageJump={false}
          showPagination={false}
        />
      </RelatedSolutionsWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RelatedSolutionsTable/RelatedSolutionsTable.tsx